import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DataRefreshDate, ILocationService, LocationItem, LocationsRequest } from '../common';
import { ApiMethodConstants } from '../common/api-method.constants';
import { ApiBuilder } from '../common/api-url-builder';
import { ApiEnvironmentService } from '../api-environment.service';

@Injectable()
export class HealthCenterLocationsService implements ILocationService {
  constructor(private httpClient: HttpClient, private apiBuilder: ApiBuilder, private apiService: ApiEnvironmentService) {}

  public getLocations(request: LocationsRequest): Promise<LocationItem[]> {
    const url = this.apiBuilder.buildUrl(request, ApiMethodConstants.HealthCenters);
    const headers = new HttpHeaders({
      Accept: '*/*'
    });

    return this.httpClient
      .get(url, { headers: headers })
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(this.handleError);
  }

  private handleError(error: any): Promise<any> {
    console.error('Error getting name suggestions from a name suggestion service.');
    return Promise.reject(error.message || error);
  }

  public getRefreshDate(): Promise<DataRefreshDate> {
    const apiBaseHref = this.apiService.getApiBaseHref();
    const url = encodeURI(`${apiBaseHref}/HealthCenters/DataRefreshDate`);
    const headers = new HttpHeaders({
      Accept: '*/*'
    });

    return this.httpClient
      .get(url, { headers: headers })
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(this.handleError);
  }

  public getMSHSRefreshDate(): Promise<DataRefreshDate> {
    const apiBaseHref = this.apiService.getApiBaseHref();
    const url = encodeURI(`${apiBaseHref}/MSHS/DataRefreshDate`);
    const headers = new HttpHeaders({
      Accept: '*/*'
    });

    return this.httpClient
      .get(url, { headers: headers })
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(this.handleError);
  }
}
